export default "__VITE_ASSET__cce6c65c__"